import { useEffect, useState } from "react";
import { _DocumentFactory, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../theme/Component/PrintJson";
import useModal, { MODAL_LG, MODAL_XL } from "../../theme/Component/hooks/useModal";
import { Modal } from "../../theme/Component/Modal";
import { ExcecuteRemoteAbstract } from "../../system/remoteAbstractAction/ExcecuteRemoteAbstract";

interface Props {
    document: any;
}
export const BodegaDocumentosMenu = ({ document }: Props) => {

    const { lista, setLista, instance } = useDataBean(_DocumentFactory);
    const [menu, setMenu] = useState<any>([]);
    const [remote, setRemote] = useState<any>({});
    const modalRemote = useModal('Acción', MODAL_XL);

    useEffect(() => {
        if (document.IDDocument)
            instance.getAccountantDocumentMenu(document.IDDocument, document.Since, _single.getAccountID()).then(
                (resp: any) => {

                    if (resp) {
                        setMenu(Object.getOwnPropertyNames(resp));
                    }

                    setLista(resp);
                }
            )
    }, [])

    useEffect(() => {

        console.log(remote);

        if (remote.ClassForName) {
            modalRemote.open();
        }
    }, [remote])
    return (
        <div className="row">
            <div className="col">

                {menu.length > 0 &&
                    menu.map((m, i) => {
                        return (
                            <div key={i} className="btn-group shadow">
                                <button type="button" className="btn btn-light shadow-none">{m}</button>
                                <button type="button" className="btn btn-light shadow-none dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button>
                                <div className="dropdown-menu">
                                    {lista[m].length > 0 && lista[m].map((item: any, index) => {
                                        return (
                                            <span key={index} className="dropdown-item cursor" onClick={() => { setRemote({ ...item, ...document }) }}>{item.Name}</span>

                                        )
                                    })}
                                </div>
                            </div>
                        )
                    })
                }

            </div>
            <div className="col-md-12">
                <Modal modal={modalRemote.modal} updateModal={modalRemote.setModal} >
                    <div className="row">
                        <div className="col">
                            {/* <PrintJson json={remote} /> */}
                            <ExcecuteRemoteAbstract remoteAbstractAction={remote} isMenu={true} />
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}